/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { AttemptStatus } from './AttemptStatus';
import {
    AttemptStatusFromJSON,
    AttemptStatusFromJSONTyped,
    AttemptStatusToJSON,
    AttemptStatusToJSONTyped,
} from './AttemptStatus';

/**
 * 
 * @export
 * @interface LearnAttemptSummary
 */
export interface LearnAttemptSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    activityKey: string;
    /**
     * 
     */
    status: AttemptStatus;
    /**
     * 
     */
    version: number;
    /**
     * **Client-reported and untrusted.** Named for what it is: nothing server-side verifies it.
     * Do not rank a leaderboard on this value without server-side scoring.
     * 
     * The bounds are the storage column, not a game rule: `learn_attempts.client_score` is
     * `numeric(12, 4)`. Without them an arcade-style score like `1000000000` passes validation
     * and Postgres then raises `numeric field overflow` (22003) — a 5xx on a surface where
     * section 5 forbids one, carrying a slug that section 6's exhaustive table does not list.
     * A validator rejecting it up front is the shape the contract already uses everywhere else.
     * 
     */
    clientScore?: number | null;
    /**
     * 
     */
    startedAt: Date;
    /**
     * 
     */
    completedAt?: Date | null;
}



/**
 * Check if a given object implements the LearnAttemptSummary interface.
 */
export function instanceOfLearnAttemptSummary(value: object): value is LearnAttemptSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('activityKey' in (value as Record<string, any>)) && !('activity_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['activityKey'] === undefined && (value as Record<string, any>)['activity_key'] === undefined)) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if ((!('startedAt' in (value as Record<string, any>)) && !('started_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['startedAt'] === undefined && (value as Record<string, any>)['started_at'] === undefined)) return false;
    return true;
}

export function LearnAttemptSummaryFromJSON(json: any): LearnAttemptSummary {
    return LearnAttemptSummaryFromJSONTyped(json, false);
}

export function LearnAttemptSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearnAttemptSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'activityKey': json['activity_key'],
        'status': AttemptStatusFromJSON(json['status']),
        'version': json['version'],
        'clientScore': json['client_score'] === undefined ? undefined : json['client_score'] === null ? null : json['client_score'],
        'startedAt': (json['started_at'] == null ? json['started_at'] : parseDateTime(json['started_at'])),
        'completedAt': json['completed_at'] === undefined ? undefined : json['completed_at'] === null ? null : (parseDateTime(json['completed_at'])),
    };
}

export function LearnAttemptSummaryToJSON(json: any): LearnAttemptSummary {
    return LearnAttemptSummaryToJSONTyped(json, false);
}

export function LearnAttemptSummaryToJSONTyped(value?: LearnAttemptSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'activity_key': value['activityKey'],
        'status': AttemptStatusToJSON(value['status']),
        'version': value['version'],
        'client_score': value['clientScore'],
        'started_at': value['startedAt'] == null ? value['startedAt'] : serializeDateTime(value['startedAt']),
        'completed_at': value['completedAt'] == null ? value['completedAt'] : serializeDateTime(value['completedAt']),
    };
}

